import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api';

const EditLead = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [leadData, setLeadData] = useState({
        staff_id: 1,
        name: '',
        number: '',
        followup_date: '',
        description: '',
        status: 'pending',
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        // Fetch existing lead data
        fetch(`${BASE_URL}leads/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setLeadData({
                        staff_id: data.data.staff_id,
                        name: data.data.name,
                        number: data.data.number,
                        followup_date: data.data.followup_date,
                        description: data.data.description,
                        status: data.data.status,
                    });
                } else {
                    alert('Failed to fetch lead data');
                    navigate('/LeadsList'); // Redirect if fetch fails
                }
            })
            .catch(error => {
                console.error('Error fetching lead:', error);
                alert('An error occurred while fetching the lead.');
            });
    }, [id, navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setLeadData(prevData => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        fetch(`${BASE_URL}leads/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(leadData),
        })
            .then(response => response.json())
            .then(data => {
                setIsSubmitting(false);
                if (data.status === 1) {
                    alert('Lead updated successfully!');
                    navigate('/LeadsList'); // Redirect after success
                } else {
                    alert('Failed to update lead. Please try again.');
                }
            })
            .catch(error => {
                setIsSubmitting(false);
                console.error('Error updating lead:', error);
                alert('An error occurred. Please try again.');
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Lead</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="card">
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="name"
                                    value={leadData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label>Number</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="number"
                                    value={leadData.number}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label>Follow-Up Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    name="followup_date"
                                    value={leadData.followup_date}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label>Description</label>
                                <textarea
                                    className="form-control"
                                    name="description"
                                    value={leadData.description}
                                    onChange={handleChange}
                                    required
                                ></textarea>
                            </div>

                            <div className="form-group">
                                <label>Status</label>
                                <select
                                    className="form-control"
                                    name="status"
                                    value={leadData.status}
                                    onChange={handleChange}
                                >
                                    <option value="pending">Pending</option>
                                    <option value="closed">Closed</option>
                                </select>
                            </div>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Updating...' : 'Update Lead'}
                            </button>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditLead;
